import Axios, { Method } from "axios";
import { errorCatcher } from "../../hooks";
import { PluginApiResult } from "./types";

// #region pluginRequest
/**
 * Axios call with `X-Wallmates-Auth` that never throws: failures come back as
 * `{ ok: false, status, message }` with the API's `{ message }` (402 / 409 / 400
 * texts are meant to be shown to the brand verbatim).
 */
export const pluginRequest = async <T>(
    method: Method,
    url: string,
    authToken: string | null,
    logout: () => void,
    body?: unknown
): Promise<PluginApiResult<T>> => {
    try {
        const result = await Axios.request<T>({
            method,
            url,
            data: body,
            headers: { 'X-Wallmates-Auth': authToken },
            timeout: 30_000
        });
        return { ok: true, data: result.data };
    } catch (err: any) {
        errorCatcher(err, logout);
        const status: number = err?.response?.status ?? 0;
        const message: string = err?.response?.data?.message
            || (status === 0 ? 'Could not reach Wallmates. Check your connection and try again.' : 'Something went wrong. Please try again.');
        return { ok: false, status, message };
    }
};
